(function(){

    function showLimitMessage(msg) {
  // vorhandenes Overlay entfernen
  const old = document.getElementById('limit-overlay');
  if (old) old.remove();

  // Overlay erstellen
  const overlay = document.createElement('div');
  overlay.id = 'limit-overlay';
  Object.assign(overlay.style, {
    position: 'fixed',
    top: '0',
    left: '0',
    width: '100vw',
    height: '100vh',
    background: 'rgba(0, 0, 0, 0.4)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    opacity: '0',
    transition: 'opacity 0.3s ease',
    zIndex: '9999'
  });

  // Pop-up-Box
  const box = document.createElement('div');
  Object.assign(box.style, {
    background: '#fff',
    padding: '1.25rem 1.5rem',
    borderRadius: '0.5rem',
    boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
    maxWidth: '90%',
    textAlign: 'center',
    fontSize: '1.3rem',
    lineHeight: '1.4',
    color: '#333'
  });
  box.textContent = msg;

  overlay.appendChild(box);
  document.body.appendChild(overlay);

  // Fade-in
  requestAnimationFrame(() => {
    overlay.style.opacity = '1';
  });

  // nach 2 Sek. ausblenden und entfernen
  setTimeout(() => {
    overlay.style.opacity = '0';
    overlay.addEventListener('transitionend', () => {
      overlay.remove();
    }, { once: true });
  }, 2000);
}


  function wrapQty() {
    if (typeof window.onClickQtyPlusMinus !== 'function') {
      console.log('⏳ onClickQtyPlusMinus noch nicht da');
      return false;
    }
    console.log('✅ onClickQtyPlusMinus gefunden – wir wrappen jetzt');
    const orig = window.onClickQtyPlusMinus;

    window.onClickQtyPlusMinus = function(btn) {
      console.log('🔔 wrapped onClickQtyPlusMinus', btn);
      const wrapper = btn.closest('.quantity-wrapper');
      const input   = wrapper && wrapper.querySelector('input');
      if (!input) {
        console.log('– kein Input gefunden, Original aufrufen');
        return orig(btn);
      }

      const mode   = btn.dataset.mode;
      const current= parseInt(input.value, 10) || 0;
      let newQty   = mode === 'plus' ? current + 1 : current - 1;
      const minQty = parseInt(input.dataset.minQty, 10) || 0;

      // Limit ermitteln
      let limit = 0;
      if (input.dataset.productTags) {
        input.dataset.productTags.split(' ').forEach(tag => {
          if (tag.startsWith('limit-')) limit = parseInt(tag.split('-')[1], 10);
        });
      }
      if (!limit) {
        const atc = document.querySelector('.btn-atc[data-limit]');
        limit = atc ? parseInt(atc.dataset.limit, 10) : 0;
      }
      console.log('– aktueller Wert:', current, 'neuer Wert:', newQty, 'Limit:', limit);

      // min/max anwenden
      if (newQty < minQty) newQty = minQty;
      if (limit && newQty > limit) {
        console.log('⚠️ Limit überschritten');
        return showLimitMessage(`Die maximale Bestellmenge für diesen Artikel ist: ${limit} Stk.`, wrapper);
      }

      // alles okay: Original ausführen
      console.log('✅ innerhalb der Grenzen – Original aufrufen');
      orig(btn);

      // im Warenkorb: onchange feuern
      if (input.name === 'updates[]') {
        input.dispatchEvent(new Event('change'));
      }

      // Buttons neu prüfen
      if (typeof window.updateLimitButtons === 'function') {
        console.log('– updateLimitButtons aufrufen');
        window.updateLimitButtons();
      }
    };

    return true;
  }

  document.addEventListener('DOMContentLoaded', function(){
    console.log('DOMContentLoaded – versuche Wrapper');
    if (!wrapQty()) {
      const h = setInterval(function(){
        if (wrapQty()) {
          clearInterval(h);
          console.log('Wrapper bereit nach Polling');
        }
      }, 200);
    }
    });
  
  function updateLimitButtons() {
    fetch('/cart.js')
      .then(r => r.json())
      .then(cart => {
        document.querySelectorAll('.btn-buy, .btn-atc').forEach(btn => {
          console.log("btn", btn);

           // Skip buttons with 'deactived' attribute
        if (btn.hasAttribute('deactived') || btn.textContent.trim() === 'Ausverkauft') {
          return;
        }
          
          const limit = parseInt(btn.dataset.limit, 10);
          if (!limit || limit < 1) return btn.disabled = false;

          const form = btn.closest('form');
          const variantField = form && form.querySelector('input[name="id"], select[name="id"]');
if (!variantField) return btn.disabled = false;
const variantId = parseInt(variantField.value, 10);
          
          const qtyInCart = cart.items
            .filter(item => item.variant_id === variantId)
            .reduce((sum, item) => sum + item.quantity, 0);

          btn.disabled = qtyInCart >= limit;
          
          if (qtyInCart >= limit) {
            btn.classList.add('disabled-by-limit');
            
          } else {
            btn.classList.remove('disabled-by-limit');
          }

          const isAvailable = btn.dataset.available !== 'false';
        btn.disabled = qtyInCart >= limit || !isAvailable;
          
        });
      })
      .catch(() => {
        document.querySelectorAll('.btn-buy, .btn-atc').forEach(btn => btn.disabled = false);
      });
  }

  // 👇 global machen
  window.updateLimitButtons = updateLimitButtons;

  document.addEventListener('DOMContentLoaded', updateLimitButtons);

  window.addEventListener('updated.ecomify.cart', () => {
    console.log('✅ Event "updated.ecomify.cart" wurde ausgelöst');
    updateLimitButtons();
  });
})();
